import React from 'react';
import PropTypes from 'prop-types';

import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { getResourceErrorsOverride } from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { MetaResourceRenderer } from './MetaResourceRenderer';

const defaultMetaOverrideSet = buildFacetDesignOverride();

export const MetaCollectionRenderer = ({
  collection,
  layout,
  metaOverrideSet,
  LayoutProps,
  limit,
  errors,
  onSubmit,
}) => {
  return (
    <>
      {collection.resources().list().map((res, idx) => {
        if (limit !== undefined && idx >= limit) {
          return <></>;
        }

        const resourceErrorsOverride = getResourceErrorsOverride(errors, idx);
        return <MetaResourceRenderer key={res.instanceId()} resource={res} layout={layout} LayoutProps={LayoutProps} metaOverrideSet={metaOverrideSet} onSubmit={onSubmit} errors={resourceErrorsOverride} />;
      })}
    </>
  );
};

MetaCollectionRenderer.defaultProps = {
  metaOverrideSet: defaultMetaOverrideSet,
  LayoutProps: {},
  onSubmit: null,
  errors: null,
};

MetaCollectionRenderer.propTypes = {
  metaOverrideSet: PropTypes.object,
  collection: PropTypes.arrayOf(PropTypes.object).isRequired,
  LayoutProps: PropTypes.object,
  layout: PropTypes.func.isRequired,
  limit: PropTypes.number,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
};
